<div class="ui-fluid ng-main" [ngClass]="theme">
    <div [class.hidden]="!showLoader" class="np-loader">
        <p-progressSpinner strokeWidth="5"></p-progressSpinner>
    </div>
    <router-outlet></router-outlet>
</div>

